
import { apiSlice } from "./apiSlice";
import { COACHINGCENTER_URL } from "../constants";

export const coachingCenterApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ======================================================
    // Create Coaching Center
    // ======================================================

    createCoachingCenter: builder.mutation({
      query: (data) => ({
        url: COACHINGCENTER_URL,
        method: "POST",
        body: data,
      }),

      invalidatesTags: ["CoachingCenter"],
    }),

    // ======================================================
    // Get All Coaching Centers
    // ======================================================
    //
    // Supports optional query parameters:
    //
    // ?search=abc
    // &page=1
    // &limit=20
    //
    // ======================================================

    getCoachingCenters: builder.query({
      query: (params = {}) => ({
        url: COACHINGCENTER_URL,
        params,
      }),

      providesTags: ["CoachingCenter"],

      keepUnusedDataFor: 5,
    }),

    // ======================================================
    // Get Coaching Center Details
    // ======================================================

    getCoachingCenterDetails: builder.query({
      query: (id) => ({
        url: `${COACHINGCENTER_URL}/${id}`,
      }),

      providesTags: ["CoachingCenter"],

      keepUnusedDataFor: 5,
    }),

    // ======================================================
    // Update Coaching Center
    // ======================================================

    updateCoachingCenter: builder.mutation({
      query: (data) => ({
        url: `${COACHINGCENTER_URL}/${data.coachingCenterId}`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["CoachingCenter"],
    }),

    // ======================================================
    // Delete Coaching Center
    // ======================================================

    deleteCoachingCenter: builder.mutation({
      query: (id) => ({
        url: `${COACHINGCENTER_URL}/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: ["CoachingCenter"],
    }),
  }),
});

export const {
  useCreateCoachingCenterMutation,

  useGetCoachingCentersQuery,

  useLazyGetCoachingCentersQuery,

  useGetCoachingCenterDetailsQuery,

  useUpdateCoachingCenterMutation,

  useDeleteCoachingCenterMutation,
} = coachingCenterApiSlice;
